import { resourceReducer, getResources } from 'redux-resource';

const devices = resourceReducer('devices');

export default devices;

export const getAllDevices = (state) => getResources(state);
export const getDevice = (state, id) => getResources(state, [id])[0];
